import { useSelector } from "react-redux";

export default function useSlides() {
    return useSelector(state => state.game.questions[0].slides);
}